import { Fade, Grid, Box } from "@mui/material";
import { useState } from "react";
import { useListContext } from "react-admin";
import { useWebsite } from "../../hooks";
import type { Brand, Offer } from "../../models";
import { OfferCard } from "./OfferCard";

export const ShopGrid = (): JSX.Element => {
    const website = useWebsite();
    const { data = [] } = useListContext<Offer>();
    const brands = website.brands as unknown as Brand[];
    return (
        // <ReactPullToRefresh onRefresh={handleRefresh}>
        <Grid container spacing={2}>

                {data.map((offer) => {
                    const variants = offer.variants.map(variant => {
                        return {
                            ...variant,
                            details: variant.details.map(detail => {
                                const brand = brands.find(x => x.brandId === detail.brandId);
                                return {
                                    ...detail,
                                    brand: brand?.name ?? "",
                                    brandImage: brand?.image,
                                    brandColor: brand?.color,
                                };
                            }),
                        };
                    });
                    return <GridItem key={offer.id} offer={{ ...offer, variants }} taxRate={website.taxRate} />;
                })}
            </Grid>
        // </ReactPullToRefresh>
    );
};

function GridItem({ offer, taxRate }: { offer: Offer; taxRate: number }): JSX.Element {
    const variantIndex = useState(0);
    const detailIndex = useState(0);
    return (
        <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 3 }}>
            <Fade in={true}>
                <Box>
                    <OfferCard
                        offerIndex={variantIndex}
                        detailIndex={detailIndex}
                        offer={offer}
                        currency={/*website.currency ?? */ "USD"}
                        taxRate={taxRate}
                        sx={{ height: 256 }}
                    />
                </Box>
            </Fade>
        </Grid>
    );
}
